"use strict";

exports.__esModule = true;
exports.AuditLogListScreen = AuditLogListScreen;
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _App = require("../../App");
var _Report = require("../../Report");
var _AuditLogGrid = require("../AuditLogGrid");
var _AuditLogListToolbar = require("../AuditLogListToolbar");
var _reactRouterDom = require("react-router-dom");
var _System = require("../../../System");
var _AuditLogDetails = require("../AuditLogDetails/AuditLogDetails");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "AuditLogListScreen__Wrapper",
  componentId: "sc-16sztgq-0"
})(["display:flex;flex-direction:column;height:100vh;"]);
var GridWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AuditLogListScreen__GridWrapper",
  componentId: "sc-16sztgq-1"
})(["flex:1 1 auto;position:relative;"]);
function AuditLogListScreen() {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("AuditLogListScreen.title", "Audit Log")
  }, /*#__PURE__*/_react["default"].createElement(_Core.MasterDetailView, {
    selected: undefined,
    onSelect: function onSelect() {},
    renderMaster: function renderMaster() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
        title: translate("AuditLogListScreen.navbar.title", "Audit Log")
      }), /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, null, /*#__PURE__*/_react["default"].createElement(_Report.StandardReportDataProvider, {
        timeRangeKind: "multiDay"
      }, /*#__PURE__*/_react["default"].createElement(_AuditLogListToolbar.AuditLogListToolbar, null), /*#__PURE__*/_react["default"].createElement(GridWrapper, null, /*#__PURE__*/_react["default"].createElement(_Core.ComponentSize, null, function (_ref) {
        var width = _ref.width,
          height = _ref.height;
        return /*#__PURE__*/_react["default"].createElement(_Report.Report, {
          config: _AuditLogGrid.config,
          width: width,
          height: height
        });
      }))))));
    },
    renderDetail: function renderDetail() {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.RootRoutes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: (0, _System.getScreenPath)("AuditLogDetails"),
        element: /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.CompatRoute, {
          render: function render(props) {
            var auditLogId = props.match.params.id;
            if (auditLogId) {
              return /*#__PURE__*/_react["default"].createElement(_AuditLogDetails.AuditLogDetails, _extends({}, props, {
                auditLogId: auditLogId,
                isFullScreen: true
              }));
            }
            return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
              error: new Error("id is undefined")
            });
          }
        })
      }));
    }
  }));
}